import * as React from "react";

type Props = React.HTMLAttributes<HTMLDivElement> & {
    text?: string|React.ReactNode
}

export function FieldErrorMessage({
  id,
  text,
  children,
}: Props) {
  return (
    <div id={id} role="alert" data-field-error>
      {text || children}
    </div>
  );
}
